<template>
  <div id="viewTicketModal">
    <transition name="fade">
      <div v-if="isModalVisible" class="fixed inset-0 z-40">
        <div
          class="absolute inset-0 bg-black bg-opacity-75"
          @click.self="closeModal"
        ></div>
        <div
          class="flex flex-col items-center justify-center w-screen h-screen"
        >
          <div class="relative animodal-inner">
            <div
              class="rounded-lg bg-white border w-[300px] lg:w-[500px] border-stone-500 overflow-hidden"
            >
              <div class="text-center">
                <div class="" v-if="exitUploadMessage !== null">
                  <font-awesome-icon
                    class="text-green-600 z-20 h-28 py-2"
                    icon="fa-check-circle"
                  />
                </div>
                <font-awesome-icon
                  v-if="exitUploadMessageError !== null"
                  class="text-red-600 z-20 h-28 py-2"
                  icon="fa-check-circle"
                />
              </div>
              <div class="p-4" v-if="exitUploadMessage !== null">
                <div class="text-lg font-bold text-center text-black">
                  Exited Staff Request Submitted Successfully
                </div>
                <div class="mt-4 text-sm text-center">
                  Kindly track processing status from Ticket menu using your
                  Case Number
                  <div class="block font-bold">{{ exitUploadMessage }}</div>
                </div>
              </div>
              <div class="" v-if="exitUploadMessageError !== null">
                <div class="text-lg font-bold text-center text-black">
                  Exited Staff Request Failed
                </div>
                <div class="mt-4 text-sm text-center">
                  <div class="block font-bold">
                    {{ exitUploadMessageError }}
                  </div>
                </div>
              </div>
              <form
                v-if="
                  exitUploadMessage === null && exitUploadMessageError === null
                "
                @submit.prevent="markUserAsExit"
                class="px-6 py-3"
              >
                <div class="text-center"></div>
                <div>Mark as Exit</div>
                <div class="border-b-gray-400 border-b mt-2"></div>
                <div class="text-black text-center text-sm my-3">
                  Mark
                  <span class="text-red-600 font-bold uppercase"
                    >{{ getContact.first_name }}
                    {{ getContact.last_name }}</span
                  >
                  as <span class="text-red-600">exited</span>
                </div>
                <div>
                  <div class="mt-4">
                    <label for="" class="block"
                      >Mode of Exit
                      <span class="text-red-700 text-sm">*</span></label
                    >
                    <select
                      name=""
                      id=""
                      v-model="ModeOfExit"
                      required
                      class="w-full cursor-pointer py-2 rounded bg-[#E5E7EB] text-gray-800 leading-tigh focus:outline-none focus:shadow-outline"
                    >
                      <option value="">Select</option>
                      <option value="retirement">Retirement</option>
                      <option value="company folded up/liquidated">
                        Company Folded up/Liquidated
                      </option>
                      <option value="deceased">Deceased</option>
                      <option value="disengaged">Disengaged</option>
                      <option value="No longer in employment">
                        No Longer in Employment
                      </option>
                      <option value="Not known by the employer">
                        Not Known by the Employer
                      </option>
                    </select>
                    <div class="my-4">
                      <label for=""
                        >Date of Exit
                        <span class="text-red-700 text-sm">*</span></label
                      >
                      <Datepicker
                        :enableTimePicker="false"
                        class="appearance-none w-full py-2 rounded text-gray-800 leading-tight md:py-0 focus:outline-none focus:shadow-outline"
                        style="background: none; border: none"
                        v-model="DateOfExit"
                        required
                      ></Datepicker>
                    </div>
                  </div>
                </div>
                <div class="flex justify-end mt-3">
                  <div>
                    <button
                      @click.prevent="closeModal"
                      :class="
                        exitModalLoading
                          ? 'bg-gray-500 cursor-not-allowed'
                          : 'bg-red-600'
                      "
                      class="text-white text-sm mr-3 p-3 rounded-lg"
                    >
                      <span>Cancel</span>
                    </button>
                    <button
                      type="submit"
                      :disabled="exitModalLoading"
                      :class="
                        exitModalLoading
                          ? 'bg-gray-500 cursor-not-allowed'
                          : 'bg-green-600'
                      "
                      class="text-white text-sm p-3 rounded-lg"
                    >
                      <span v-if="exitModalLoading">
                        <div
                          role="status"
                          class="flex justify-center w-full"
                          v-if="exitModalLoading === true"
                        >
                          Submitting
                        </div>
                      </span>
                      <span v-else>Confirm</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { ref } from "vue";
import { engageAxios, toolkitAxios } from "@/env";
import { useStore } from "vuex";
export default {
  props: {
    getContact: {
      type: [String, Object],
      required: true,
      default: () => ({}),
    },
    // ModeOfExit: String,
    // DateOfExit: Date,
    // isModalOpen: Boolean,
    isModalVisible: Boolean,
    // exitModalLoading: Boolean,
  },
  setup(props, { emit }) {
    const ModeOfExit = ref("");
    const DateOfExit = ref(new Date());
    const isModalOpen = ref(false);
    const exitUploadMessageError = ref(null);
    const exitUploadMessage = ref(null);
    const store = useStore();
    const exitModalLoading = ref(false);
    // const { isModalVisible } = toRefs(props);

    const closeModal = () => {
      if (exitModalLoading.value) return;
      emit("close-modal");
      exitModalLoading.value = false;
    };

    const getStaffAndOpenModal = () => {
      props.getContact;
      // isModalOpen.value = !isModalOpen.value;
      exitUploadMessage.value = null;
      exitUploadMessageError.value = null;
    };

    const markUserAsExit = async () => {
      exitModalLoading.value = true;
      exitUploadMessage.value = null;
      console.log("we are here");
      const exitDate = new Date(DateOfExit.value).toISOString().split("T")[0];
      const getFullName =
        props.getContact.first_name + " " + props.getContact.last_name;

      const finalDesc =
        "Staff Name: " +
        getFullName +
        " \n " +
        "Exit Date: " +
        exitDate +
        " \n " +
        "Mode of Exit: " +
        ModeOfExit.value +
        " \n ";

      const finalDto = {
        caseOriginCode: "700000008",
        employerCode: store.state.getLoggedInUser.code,
        interactionType: "700000000",
        interactionCategory: "bddc2993-081d-eb11-a813-000d3a64a52d",
        interactionSubCategory: "c47be674-091d-eb11-a813-000d3a64a52d",
        documents: "",
        caseDescription: finalDesc,
        agentCode: store.state.getLoggedInUser.rmu_code,
        autoRoute: true,
        subject: store.state.getLoggedInUser.code + "-Exited Staff",
      };

      return new Promise((resolve) => {
        engageAxios
          .post("crm/case/employer/createcase", finalDto)
          .then((response) => {
            const postData = {
              code: finalDto.employerCode,
              staff_name: getFullName,
              date: exitDate,
              mode: "Employer Web",
              staff_pin: props.getContact.pin,
              agentCode: finalDto.agentCode,
            };

            toolkitAxios.post("case/exitedStaff", postData).then(() => {
              resolve(response);
              exitUploadMessage.value = response.data.data.caseNumber;
              exitModalLoading.value = false;
            });

            resolve(true);
          })
          .catch(() => {
            exitUploadMessageError.value =
              "An error occured when submitting your request, please try again later.";
            exitModalLoading.value = false;
          });
      });
    };

    return {
      ModeOfExit,
      DateOfExit,
      isModalOpen,
      exitModalLoading,
      // isModalVisible,
      getStaffAndOpenModal,
      markUserAsExit,
      exitUploadMessage,
      exitUploadMessageError,
      closeModal,
    };
  },
};
</script>

<style></style>
